import { renderSelectPrompt, renderSuccess } from '@shopify/cli-kit/node/ui';
import { AbortError } from '@shopify/cli-kit/node/error';
import { logout as logout$1, ensureAuthenticatedBusinessPlatform, ensureAuthenticatedAdmin } from '@shopify/cli-kit/node/session';
import { normalizeStoreFqdn } from '@shopify/cli-kit/node/context/fqdn';
import { resetConfig, getConfig, setUserAccount } from './shopify-config.js';
import { getUserAccount } from './graphql/business-platform/user-account.js';
import { enhanceAuthLogs } from './log.js';

async function logout(root) {
  await logout$1();
  await resetConfig(root);
}
async function login(root, shop) {
  enhanceAuthLogs(false);
  const forcePrompt = shop === true;
  const existingConfig = root ? await getConfig(root) : {};
  let { email, shopName } = existingConfig;
  if (typeof shop !== "string") {
    shop = existingConfig.shop;
  }
  if (shop) shop = await normalizeStoreFqdn(shop);
  if (!shop || !shopName || !email || forcePrompt || shop !== existingConfig.shop) {
    const token = await ensureAuthenticatedBusinessPlatform().catch(() => {
      throw new AbortError(
        "Unable to authenticate with Shopify. Please report this issue."
      );
    });
    const userAccount = await getUserAccount(token);
    const preselected = !forcePrompt && shop && userAccount.activeShops.find(({ fqdn }) => shop === fqdn);
    const selected = preselected || await renderSelectPrompt({
      message: "Select a shop to log in to",
      choices: userAccount.activeShops.map(({ name, fqdn }) => ({
        label: `${name} (${fqdn})`,
        value: { name, fqdn }
      }))
    });
    shop = selected.fqdn;
    shopName = selected.name;
    email = userAccount.email;
  }
  const session = await ensureAuthenticatedAdmin(shop).catch(() => {
    throw new AbortError("Unable to authenticate with Shopify", void 0, [
      `Ensure the shop that you specified is correct (you are trying to use: ${shop})`
    ]);
  });
  const config = root ? await setUserAccount(root, { shop, shopName, email }) : { shop, shopName, email };
  return { session, config };
}
function renderLoginSuccess(config) {
  renderSuccess({
    headline: "Shopify authentication complete",
    body: [
      "You are logged in to",
      { userInput: config.shopName ?? config.shop ?? "your store" },
      ...config.email ? ["as", { userInput: config.email }] : []
    ]
  });
}

export { login, logout, renderLoginSuccess };
